"use client";

import { Box, Button, Dialog, IconButton } from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { montserrat } from "@/lib/font";
import { useAppSelector } from "@/lib/hooks";
import { useTranslations } from "next-intl";

interface PopupPurchaseSuccessProps {
  handleClose: () => void;
  handleOpenPopupDownload?: () => void;
}

const PopupPurchaseSuccess = (props: PopupPurchaseSuccessProps) => {
  const t= useTranslations("messages");
  const { handleClose, handleOpenPopupDownload } = props;
  const { isPurchaseCompleted } = useAppSelector((state) => state.report);
  const handleDownload = () => {
    handleClose();
    handleOpenPopupDownload?.();
  };


  return (
    <Dialog
      maxWidth="sm"
      open={isPurchaseCompleted}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <Box className={`pt-4 pb-8 border-gray_20 ${montserrat}`}>
        <Box className="gap-8 grid px-6">
          <Box className="flex justify-between items-center">
            <Box className="flex items-center">
              <span translation-key="report_popup_purchase_success_message_title" className="text-gray_90 font-bold text-xl/7">
                {t("report_popup_purchase_success_message_title")}
              </span>
            </Box>
            <Box>
              <IconButton
                className="!bg-eerie_black_5 !size-8 !p-1"
                onClick={handleClose}
              >
                <CloseIcon className="text-[rgba(28, 28, 28, 0.4)]" />
              </IconButton>
            </Box>
          </Box>
          <Box className="gap-6 grid">
            <Box>
              <span translation-key="report_popup_purchase_success_message_description" className="text-gray_90 text-sm/6 font-medium">
                {t("report_popup_purchase_success_message_description")}
              </span>
            </Box>
            <Box className="flex justify-center gap-4">
              <Button
                variant="outlined"
                className="!bg-ciBlue_200 w-full !rounded !py-1 !pl-2 !pr-3 gap-2 flex !border-0 hover:!bg-ciBlue_2 hover:!border-[0.1px] hover:!border-ciBlue_light_2"
                onClick={handleClose}
              >
                <Box className="py-1 gap-[10px] grid">
                  <span translation-key="report_popup_purchase_success_button_view" className="font-medium text-base/6 text-ciBlue_900 normal-case">
                    {t("report_popup_purchase_success_button_view")}
                  </span>
                </Box>
              </Button>
              <Button
                variant="outlined"
                className="!bg-cimigo-blue w-full !rounded !py-1 !pl-2 !pr-3 gap-2 flex !border-0 hover:!bg-cimigo_blue_light_1"
                onClick={handleDownload}
              >
                <Box className="py-1 gap-[10px] grid">
                  <span className="font-medium text-base/6 text-white normal-case" translation-key={"popup_purchase_success_button"}>
                     {t("common_download_now")}
                  </span>
                </Box>
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default PopupPurchaseSuccess;
